/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState } from 'react';
import { DefaultTable } from 'src/components';
import { IAddresses } from 'src/interfaces/personal-info';
import { IAddress } from 'src/interfaces/personal-info';

import { useTranslation } from 'react-i18next';
import arrowSvg from 'src/assets/arrowExpand.svg';
import { RegularButton, DataTableCellDeleteButton, DataTableCellEditButton } from 'pg-ui-library';
import ConfirmationModal from 'src/components/confirmation-model';
import { useActions } from 'src/hooks/useActions';
import { useDeleteAddress } from '../../mutations/add-delete-update.mutation';
import { MainTitle, SeparatorLineStraight, ExpandIcon, Collapsible, BelowTitle, EmergencyHeader } from './styles';
import { PersonalInfoForm } from '../..';
import { PersonalAddressModal } from './address-modal';

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
      font: 'normal normal bold 18px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 18px Biotif',
      color: '#1B1D35',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(10, 41, 41)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
    },
  },
  pagination: {
    style: {
      display: 'none',
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const AddressForm: React.FC<PersonalInfoForm> = ({ personalInfo }) => {
  const { getPersonalInfo } = useActions();
  // const workerAddress: IAddresses[] = personalInfo?.addresses ?? [];
  const workerAddress: IAddress[] = personalInfo?.address ? [personalInfo.address].flat() : [];

  const { t } = useTranslation();

  const [isTableOpen, setIsTableOpen] = useState(true);
  const expandTab = () => {
    setIsTableOpen(!isTableOpen);
  };

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [updateAddress, setUpdateAddress] = useState<IAddresses | null>(null);
  const [deleteAddresscheck, setDeleteAddresscheck] = useState<IAddresses>();
  const deleteAddressMutation = useDeleteAddress();
  const editButtonWrapper = (onClick: Function) => <DataTableCellEditButton onClick={() => onClick()} />;
  const deleteButtonWrapper = (onClick: Function) => <DataTableCellDeleteButton onClick={() => onClick()} />;

  const onEdit = (editAddress: IAddresses) => {
    setIsOpen(!modalIsOpen);
    setUpdateAddress(editAddress);
  };

  const deleteAddress = (address: IAddresses) => {
    setIsModalOpen(true);
    setDeleteAddresscheck(address);
  };

  const columns = [
    {
      name: 'Address 1',
      selector: (row: IAddress) => row.address1 || '',
      width: '350px',
      cell: (row: IAddress) => (
        <div
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'clip',
          }}
        >
          {row.address1}
        </div>
      ),
    },
    {
      name: 'Address 2',
      selector: (row: IAddress) => row.address2 || '',
      width: '350px',
      cell: (row: IAddress) => (
        <div
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'clip',
          }}
        >
          {row.address2}
        </div>
      ),
    },
    {
      name: 'City',
      selector: (row: IAddress) => row.city || '',
      width: '200px',
    },
    {
      name: 'State',
      selector: (row: IAddress) => row.state || '',
      width: '150px',
    },
    {
      name: 'Zip Code',
      selector: (row: IAddress) => row.zipcode || '',
      width: '150px',
    },
    // {
    //   name: 'Country',
    //   selector: (row: IAddress) => row.country || '',
    //   width: '150px',
    // },
    // {
    //   name: 'Actions',
    //   cell: (row: IAddress) => (
    //     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    //       {row.isPrimary === 'Yes' ? null : (
    //         <div style={{ cursor: 'pointer' }}>{editButtonWrapper(() => onEdit(row))}</div>
    //       )}
    //       {row.isPrimary === 'Yes' ? null : (
    //         <div style={{ cursor: 'pointer' }}>{deleteButtonWrapper(() => deleteAddress(row))}</div>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  const addAddress = () => {
    setIsOpen(!modalIsOpen);
    setUpdateAddress(null);
  };

  const removeAddress = async () => {
    if (!deleteAddresscheck?.id) {
      return;
    }

    try {
      await deleteAddressMutation.mutateAsync({ address: deleteAddresscheck });
      await getPersonalInfo();
    } catch (error) {
      console.error('Error deleting address:', error);
    }
  };

  const handleConfirm = () => {
    removeAddress();
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setUpdateAddress(null);
  };

  return (
    <div style={{ boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}>
      <PersonalAddressModal
        updateAddress={updateAddress ? [updateAddress] : []}
        isOpen={modalIsOpen}
        setIsOpen={setIsOpen}
      />
      <ConfirmationModal
        isOpen={isModalOpen}
        message="Are you sure want to remove this Address?"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <EmergencyHeader>
        <MainTitle>
          <ExpandIcon src={arrowSvg} onClick={() => expandTab()} isOpen={isTableOpen} />
          {t('personalInfo.address.title')}
        </MainTitle>
        {/* <div style={{ marginTop: '15px', marginRight: '27px' }}>
          <RegularButton type="button" onClick={addAddress}>
            {t('global.form.add')}
          </RegularButton>
        </div> */}
      </EmergencyHeader>
      <SeparatorLineStraight />
      <div>
        <Collapsible isOpen={isTableOpen}>
          <DefaultTable columns={columns} data={workerAddress} customStyles={customStyles} />
        </Collapsible>
      </div>
      <BelowTitle />
    </div>
  );
};

export default AddressForm;
